import { render, staticRenderFns } from "./BirthDatePicker.vue?vue&type=template&id=3df33740"
import script from "./BirthDatePicker.vue?vue&type=script&lang=ts"
export * from "./BirthDatePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports